import strings from '../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.parameter.name.label,
  disabled: true,
  validators: []
}

let value = {
  fieldKey: "value",
  type: "text",
  label: strings.form.parameter.value.label,
  validators: []
}

export const form = {
  formKye: "parameter",
  fields: [
    name,
    value
  ]
}
